<h2 mat-dialog-title>CDN Features</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="start">
      <mat-tab label="General">
        <div class="general column">
          <div class="elevated row">
            <div class="column">
              <h5>Captcha</h5>
              <span
                >Configures a reCAPTCHA protection page for the website, which can be enabled
                temporarily in the event of a bot attack.</span
              >
            </div>
            <mat-slide-toggle formControlName="captcha"></mat-slide-toggle>
          </div>

          <div class="captcha column">
            <span>Captcha level</span>
            <mat-radio-group formControlName="captchaLevel">
              <mat-radio-button [value]="false">Full</mat-radio-button>
              <mat-radio-button [value]="true">Strict</mat-radio-button>
            </mat-radio-group>
          </div>

          <div class="elevated row">
            <div class="column">
              <h5>Query String Ignore</h5>
              <span
                >If enabled, pages will be cached even when attempting to bypass the cache using
                query strings, such as ?nocache.</span
              >
            </div>
            <mat-slide-toggle formControlName="qsIgnore"></mat-slide-toggle>
          </div>

          <!-- <div class="elevated row">
            <div class="column">
              <h5>Bypass Cache</h5>
              <span
                >If enabled, the CDN will stop generating cache for the whole website. Use to force
                fresh content on a page.
              </span>
            </div>
            <mat-slide-toggle formControlName="cacheBypass"></mat-slide-toggle>
          </div> -->
        </div>
      </mat-tab>
      <mat-tab label="Bots">
        <div class="bots column">
          <app-input-field
            label="Cache referrer"
            placeholder="e.g. google.com"
            formControlName="cacheReferer"
            type="chips-autocomplete"
            hint="Only allow traffic referred from the listed domains. Unlisted referrers will receive a 403."
            class="full-width"
          ></app-input-field>

          <app-input-field
            label="Blocked user agents"
            placeholder="e.g. google.com"
            formControlName="uaList"
            type="chips-autocomplete"
            hint="Block specific user agent strings from accessing the site."
            class="full-width"
          ></app-input-field>
        </div>
      </mat-tab>
      <mat-tab label="Country">
        <div class="country column">
          <div class="elevated column">
            <div class="column">
              <h5>Manage Country Traffic</h5>
              <span
                >Block or allow traffic from specific countries using
                <a href="https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3" target="_blank">
                  ISO 3166-1 alpha-3</a
                >
                codes.</span
              >
            </div>
            <app-input-field
              placeholder="e.g. RUS, CHN"
              formControlName="countryBan"
              type="chips-autocomplete"
              class="full-width"
              [errorMessages]="ERROR_MESSAGES['countryBan']"
            ></app-input-field>
            <div class="buttons row full-width">
              <button
                matButton="elevated"
                [class.selected-red]="form.controls.countryAction.value === 'ban'"
                (click)="setCountryAction('ban')"
              >
                Ban
              </button>
              <button
                matButton="elevated"
                [class.selected-green]="form.controls.countryAction.value === 'allow'"
                (click)="setCountryAction('allow')"
              >
                Allow
              </button>

              <div class="hint">{{ countryListHint$ | async }}</div>
            </div>
          </div>

          <div class="elevated row">
            <div class="column">
              <h5>Country .htaccess</h5>
              <span
                >Passes the visitor's geolocation as an environment variable, usable in .htaccess or
                PHP without a GeoIP plugin.</span
              >
            </div>
            <mat-slide-toggle formControlName="countryHtAccess"></mat-slide-toggle>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Save Changes</button>
  <button matButton="outlined">Reset settings</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
